import { Anchor } from '@trmediaab/zebra';
import Link from 'redux-first-router-link';

export function ThemedLink({ to, href, ...props }) {
  return <Anchor as={to ? Link : 'a'} to={to} href={href} {...props} />;
}
